import type { IxfAccountingV1ManualEntryKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const ACCOUNTING_MANUAL_ENTRY_BASE_PATH = getResolvedPath('/clearing/finance/journal');

export const getAccountingManualEntryPath: EntityPathBuilder<IxfAccountingV1ManualEntryKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ACCOUNTING_MANUAL_ENTRY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.entryId) {
        return undefined;
      }

      return getResolvedPath(`${ACCOUNTING_MANUAL_ENTRY_BASE_PATH}/$entryId`, context?.keys);
    }
  }
};
